export default "__VITE_ASSET__DwyZn5VU__"